import { createClient } from '@supabase/supabase-js';

const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL || '').trim();
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY || '').trim();

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/** The project URL, for the few callers that must build a Storage endpoint by
 *  hand. Resumable (TUS) uploads are the reason this exists: supabase-js has no
 *  wrapper for them, so services/classes.ts posts to
 *  `${SUPABASE_URL}/storage/v1/upload/resumable` itself. Everything else should
 *  go through the `supabase` client above.
 *
 *  The trailing slash is stripped because the value in .env HAS one, and
 *  callers append their own path. Without this the upload endpoint came out as
 *  `https://<ref>.supabase.co//storage/v1/upload/resumable` — the double slash
 *  showed up verbatim in a failed-upload error and is the kind of thing that
 *  works until some proxy in the chain decides it does not. */
export const SUPABASE_URL = supabaseUrl.replace(/\/+$/, '');
